import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UniversalCompareHelper, UniversalTime } from "@biteinc/helpers-universal";
//#region src/utils/menu_timing_utils.ts
var menu_timing_utils_exports = /* @__PURE__ */ __exportAll({
	isActiveAt: () => isActiveAt,
	rangeThatIsActiveAt: () => rangeThatIsActiveAt,
	sortActiveTimings: () => sortActiveTimings
});
function isActiveAt(data, time, timezone) {
	return !!activeRangeAt(data, time, UniversalTime.weekTimestamp(time, timezone));
}
function rangeThatIsActiveAt(data, weekTimestamp) {
	return UniversalTime.rangeThatIsActiveAt(data, weekTimestamp);
}
function activeRangeAt(data, time, weekTimestamp) {
	if (data.dateRange && (time < data.dateRange.from || data.dateRange.to <= time)) return;
	return rangeThatIsActiveAt(data, weekTimestamp);
}
function compareActiveTimings(a, b) {
	let result = UniversalCompareHelper.descBool(!!a.timing.dateRange, !!b.timing.dateRange);
	if (result !== 0) return result;
	result = UniversalCompareHelper.ascBool(a.hasStructure, b.hasStructure);
	if (result !== 0) return result;
	result = UniversalCompareHelper.desc(a.range.from, b.range.from);
	if (result !== 0) return result;
	return UniversalCompareHelper.asc(a.range.to - a.range.from, b.range.to - b.range.from);
}
/**
* The single owner of menu timing priority: legacy serving, offline timing, and V3 selection all
* call it. Returns the timings active at `time`, highest priority first; equal priority keeps the
* input order.
*/
function sortActiveTimings(timings, timingIdWithStructureSet, time, timezone) {
	const weekTimestamp = UniversalTime.weekTimestamp(time, timezone);
	return timings.flatMap((timing) => {
		const range = activeRangeAt(timing, time, weekTimestamp);
		return range ? [{
			timing,
			range,
			hasStructure: timingIdWithStructureSet.has(timing._id.toString())
		}] : [];
	}).sort(compareActiveTimings).map(({ timing }) => timing);
}
//#endregion
export { isActiveAt, menu_timing_utils_exports, rangeThatIsActiveAt, sortActiveTimings };

//# sourceMappingURL=menu_timing_utils.js.map